<template>
  <div style="position: relative;flex:1">
    <el-scrollbar class="detail-log-box-uniq-1321" style="position: absolute;height: 100%" :always="true">
      <el-timeline v-if="cardList.length">
        <el-timeline-item type="primary" :hollow="true" :timestamp="item.recordTime" placement="top" v-for="(item, index) in cardList" :key="'djahwld'+index">
          <div class="card">
            <div class="card-title">
              {{ item.recordTitle }}
              <div class="audit-btn" v-if="hasAuditPermission(item, complaintInfo)" @click="handleAudit(item.recordId, item.complaintId)">
                审核
              </div>
              <div v-if="item.auditStatus == 0" class="status-card">待审核</div>
              <div v-if="item.auditStatus == 1" class="status-card" style="background: rgba(103, 194, 58, 1);">已审核</div>
            </div>
            <div class="card-content">
              <el-descriptions v-if="0" :column="1">
                <el-descriptions-item label="操作人:">{{ item.recordUserName }}</el-descriptions-item>
                <el-descriptions-item label="操作结果:">{{ item.result }}</el-descriptions-item>
                <el-descriptions-item label="描述:">{{ item.recordExplain }}</el-descriptions-item>
              </el-descriptions>

              <el-form>
                <el-form-item label="操作人：">{{ item.recordUserName }}</el-form-item>
                <el-form-item label="操作结果：" v-if="0">{{ item.result }}</el-form-item>
                <el-form-item label="描述：">{{ item.recordExplain }}</el-form-item>
                <el-form-item label="附件：" v-if="item.recordFiles && item.recordFiles.length">
                  <MyFileList :fileList="item.recordFiles" :columns="4"></MyFileList>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
      <div v-else style="height: 100%;display: flex;justify-content: center;align-items: center;color: #aaa">暂无数据</div>
    </el-scrollbar>
    <AuditModal ref="AuditModalRef" @handleUpdateData="handleUpdateData"></AuditModal>
  </div>
</template>

<script>
import MyFileList from "@/components/myComponents/MyFileList/index.vue";
import AuditModal from "@/components/myComponents/MyTimeLine/components/AuditModal.vue";

export default {
  name: 'MyTimeLine',
  components: {
    MyFileList,
    AuditModal
  },
  props: {
    // 字符串类型
    cardList: {
      type: Array,
      default: () => []
    },
    complaintInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      cardListDemo: [
        {
          recordTime: "2025-11-01 19:16:00",
          recordTitle: "处置动作",
          isAudit: true,
          recordUserName: "上海钢结构工程有限公司",
          result: '处置了投诉信息',
          recordExplain: '经查，投诉人 李明明 在 宝山区智慧园区建设项目 项目工作，与公司存在劳动关系，涉及欠薪金额情况属实。鉴于该欠薪问题已妥善解决，投诉人权益得到有效维护，建议对该投诉予以结案。',
          fileList: [
            {
              path: "/oss/photo/64d62d6a-16a4-4e91-88ca-35973341afc4.jpg",
              fileName: "64d62d6a-16a4-4e91-88ca-35973341afc4.jpg"
            },
            {
              path: "/oss/photo/64d62d6a-16a4-4e91-88ca-35973341afc4.jpg",
              fileName: "64d62d6a-16a4-4e91-88ca-35973341afc4.jpg"
            },
            {
              path: "/oss/photo/64d62d6a-16a4-4e91-88ca-35973341afc4.jpg",
              fileName: "核查说明.pdf"
            },
          ],
          auditStatus: 0
        },
        {
          recordTime: "2025-11-01 19:16:00",
          recordTitle: "处置动作",
          isAudit: false,
          recordUserName: "上海钢结构工程有限公司",
          result: '处置了投诉信息',
          recordExplain: '经查，投诉人 李明明 在 宝山区智慧园区建设项目 项目工作，与公司存在劳动关系，涉及欠薪金额情况属实。鉴于该欠薪问题已妥善解决，投诉人权益得到有效维护，建议对该投诉予以结案。',
          fileList: [
            {
              path: "/oss/photo/64d62d6a-16a4-4e91-88ca-35973341afc4.jpg",
              fileName: "核查说明.pdf"
            },
            {
              path: "/oss/photo/64d62d6a-16a4-4e91-88ca-35973341afc4.jp3",
              fileName: "核查说明.pdf"
            },
          ],
          readyForAudit: false,
          isAudited: false,
          auditStatus: 1
        }
      ]
    }
  },
  mounted() {
    setTimeout(() => {
      console.log('MyTimeLine接收参数', this.cardList, this.complaintInfo);
    }, 100)
  },
  methods: {
    handleAudit(recordId, complaintId) {
      console.log('审核')
      if (this.$refs.AuditModalRef) {
        this.$refs.AuditModalRef.handleOpen(recordId, complaintId);
      }
    },

    handleUpdateData() {
      this.$emit('handleUpdateData')
    },

    // 判断有没有审核的权限
    // 是待审核 并且 不是项目方 并且 （（是二级单位 并且 二级已分派） 或者 是一级单位）
    hasAuditPermission(item, complaintInfo) {
      // 是待审核 并且
      return (item.auditStatus == 0 &&
          // 不是项目方 并且
          complaintInfo.isProcess != 0 &&
          (
              // （是二级单位 并且 二级已分派）    或者
              (complaintInfo.isProcess === 2 && complaintInfo.assignStatus == 2) ||
              // 是一级单位
              (complaintInfo.isProcess === 1)
          ));
    }
  }
}
</script>

<style lang="scss">

.detail-log-box-uniq-1321 {
  width: 100%;
  height: inherit;
  padding-right: 12px;

  .el-timeline {
    padding-left: 2px;
  }

  .card {
    box-sizing: border-box;
    border-radius: 4px;
    background: rgba(241, 244, 248, 1);

    .card-title {
      padding: 0 12px;
      color: rgba(20, 31, 50, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 500;
      font-size: 12px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 37px;
      border-bottom: 1px solid rgba(233, 234, 236, 1);
      position: relative;

      .audit-btn {
        width: 54px;
        height: 22px;
        display: flex;
        place-content: center;
        place-items: center;
        gap: 16px;
        flex-shrink: 0;
        border-radius: 2px;
        background: rgba(64, 158, 255, 1);
        color: rgba(255, 255, 255, 1);
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 700;
        font-size: 12px;
        line-height: 17px;
        margin-left: 16px;
        cursor: pointer;
        user-select: none;
      }

      .status-card {
        position: absolute;
        top: 0;
        right: 0;
        width: fit-content;
        height: 28px;
        display: inline-flex;
        place-content: center;
        place-items: center;
        gap: 10px;
        flex-shrink: 0;
        padding: 10px 14px;
        border-radius:  0px 4px 0px 4px;
        background: rgba(233, 171, 79, 1);color: rgba(255, 255, 255, 1);
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
      }
    }

    .card-content {
      padding: 12px;
    }
  }

  .el-descriptions__body {
    background-color: transparent!important;
  }
  .el-descriptions__cell {
    padding-bottom: 4px!important;
  }
  .el-descriptions__label {
    color: rgba(70, 77, 90, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
  }
  .el-descriptions__content {
    color: rgba(70, 77, 90, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
  }
  .el-form-item--default {
    margin-bottom: 8px!important;
  }
  .el-form-item__label {
    line-height: 16px!important;
    height: fit-content!important;
    color: rgba(70, 77, 90, 1)!important;
    font-family: "Alibaba PuHuiTi 3.0"!important;
    font-weight: 400!important;
    font-size: 14px!important;
    padding-right: 0!important;
  }
  .el-form-item__content {
    line-height: 16px!important;
    height: fit-content!important;
    color: rgba(70, 77, 90, 1)!important;
    font-family: "Alibaba PuHuiTi 3.0"!important;
    font-weight: 400!important;
    font-size: 14px!important;
  }


  .img-up {
    width: 110px;
    height: 110px;
    position: relative;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .close-icon {
      position: absolute;
      right: 5px;
      top: 5px;
      z-index: 99;
      cursor: pointer;
    }
  }
}
</style>
